import { toHttpParams } from '@/utils/common'
import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { IProtocoloGetByCirurgiaData } from '@/types/interfaces/protocolo/protocolo-get-by-cirurgia-data.interface'
import { IProtocolo, IProtocolPendency } from '@/types/interfaces/protocolo/protocolo.interface'
import { IProtocoloGetByIdData } from '@/types/interfaces/protocolo/protocolo-get-by-id-data.interface'

const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()

export default {
  async getProtocolosByCirurgia(data: IProtocoloGetByCirurgiaData) {
    const { hospitalId, medicoId, convenioId,
      planoId, codigoDoProcedimentoPrincipal, tipoCliente } = data

    const queryParams = toHttpParams({ convenioId, planoId, codigoDoProcedimentoPrincipal, tipoCliente })

    const request = await api.get(`/hospitais/${hospitalId}/medicos/${medicoId}/protocolos-de-cirurgia?${queryParams}`)
    return factory.build<IProtocolo[]>(request)
  },

  async getProtocoloById(data: IProtocoloGetByIdData) {
    const { hospitalId, protocoloId } = data

    const request = await api.get(`/hospitais/${hospitalId}/protocolos-de-cirurgia/${protocoloId}`)
    return factory.build<IProtocolo>(request)
  },

  async blockFidelizationSurgerySolicitation(surgerySolicitationId: string) {
    const APIRequest = await api.post(`/solicitacoes/${surgerySolicitationId}/bloquear-operadora`, {})
    return factory.build(APIRequest)
  },

  async unblockFidelizationSurgerySolicitation(surgerySolicitationId: string) {
    const APIRequest = await api.post(`/solicitacoes/${surgerySolicitationId}/desbloquear-operadora`, {})
    return factory.build(APIRequest)
  },

  async openProtocolPendency(surgerySolicitationId: string, body: IProtocolPendency) {
    const APIRequest = await api.put(`/fidelizacao-abre-pendencia-protocolo-backoffice/${surgerySolicitationId}`, body)
    return factory.build(APIRequest)
  },

  async acceptDoctorJustification(surgerySolicitationId: string, backofficeReason: string) {
    const APIRequest = await api.put(`/fidelizacao-aceita-justificativa-backoffice/${surgerySolicitationId}`, { justificativaFidelizacao: backofficeReason })
    return factory.build(APIRequest)
  },

  async sendToFidelization(surgerySolicitationId: string, backofficeReason: string) {
    const APIRequest = await api.put(`/regulacao-encaminha-para-fidelizacao/${surgerySolicitationId}`, { observacaoParaFidelizacao: backofficeReason })
    return factory.build(APIRequest)
  },

  async regulacaoFazAnalise(surgerySolicitationId: string, statusFidelizacao: string, observacaoDaAnalise: string) {
    const APIRequest = await api.put(`/regulacao-faz-analise/${surgerySolicitationId}`, { statusFidelizacao, observacaoDaAnalise })
    return factory.build(APIRequest)
  },
}
